import { Component, Input } from '@angular/core';

import { TimeFilterableDataSource } from '../../datasource';

@Component({
  selector: 'igo-time-filter-item',
  template: require('./time-filter-item.component.html'),
  styles: [require('./time-filter-item.component.styl')]
})
export class TimeFilterItemComponent {

  @Input()
  get datasource(): TimeFilterableDataSource { return this._dataSource; }
  set datasource(value: TimeFilterableDataSource) {
    this._dataSource = value;
  }
  private _dataSource: TimeFilterableDataSource;

  constructor() { }

  handleYearChange(year: string | [string, string]) {
    this.datasource.filterByYear(year);
  }

  handleDateChange(date: Date | [Date, Date]) {
    this.datasource.filterByDate(date);
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/filter/time-filter-item/time-filter-item.component.ts